import { DoNotDecryptRequestsDirection } from '../../enums/DNDR/DoNotDecryptRequestsDirection';
import SubmitDoNotDecryptRequestRule from './SubmitDoNotDecryptRequestRule';

export default class SubmitDoNotDecryptRequest {

	subscriptionRequestId!: number;

	doNotDecryptRules!: SubmitDoNotDecryptRequestRule[];

	direction!: DoNotDecryptRequestsDirection;

	environment: string;

	contactId!: string;

	emergency!: boolean;

	incidentNumber!: string;

	businessJustification!: string;

	comments!: string;

	customerCoordination!: boolean;

	doNotDecryptRequestId!: number; 

	custodianApproval!: boolean;

	sevenDayExemption!: boolean;

	constructor(obj: any) {
		//this.direction = "SubscriptionToInternet"
		this.direction = new DoNotDecryptRequestsDirection().fromValue(obj.direction?.value);
		Object.assign(this, obj);
	}
}